import { render, staticRenderFns } from "./PrivacyNotice.vue?vue&type=template&id=55a0276a&scoped=true"
import script from "./PrivacyNotice.vue?vue&type=script&lang=js"
export * from "./PrivacyNotice.vue?vue&type=script&lang=js"
import style0 from "./PrivacyNotice.vue?vue&type=style&index=0&id=55a0276a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a0276a",
  null
  
)

export default component.exports